import { GoalGroupCard as GoalGroupCardType } from 'Generated/graphql-types'
import React from 'react'
import { Box } from '@material-ui/core'
import { GoalGroupCard } from '../GoalGroupCard'
import { FunderGoalSections } from '../FunderGoalSections/FunderGoalSections'
import { GoalPageHeader, GoalPageSubHeader } from './FunderGoal.styled'
import { GOAL_PAGE_SUBHEADER_TEXT } from '../utils'

type FunderGoalGroupProps = {
  goalGroup: GoalGroupCardType
  goalGroupTargetDescription: string
}

export const FunderGoalGroup = ({
  goalGroup,
  goalGroupTargetDescription,
}: FunderGoalGroupProps) => (
  <>
    <Box>
      <GoalPageHeader>Goal Overview</GoalPageHeader>
      <GoalPageSubHeader>{GOAL_PAGE_SUBHEADER_TEXT}</GoalPageSubHeader>
    </Box>
    {goalGroup && <GoalGroupCard goalGroup={goalGroup} isInteractive={false} />}
    <FunderGoalSections
      goalGroupTargetDescription={goalGroupTargetDescription}
    />
  </>
)
